{
  "title": "Agents",
  "description": "Gérer les agents IA pour les processus d'évaluation et d'assessment",
  "table": {
    "search": "Rechercher des agents...",
    "add": "Ajouter un Agent",
    "name": "Nom",
    "slug": "Slug",
    "instruction": "Instruction",
    "created_at": "Créé le",
    "actions": "Actions",
    "no_agents": "Aucun agent trouvé",
    "no_results": "Aucun résultat ne correspond à votre recherche"
  },
  "add": {
    "title": "Ajouter un Agent",
    "description": "Créer un nouvel agent IA avec des instructions personnalisées",
    "name": "Nom",
    "name_placeholder": "Entrer le nom de l'agent",
    "slug": "Slug",
    "slug_placeholder": "agent-slug",
    "instruction": "Instruction",
    "instruction_placeholder": "Entrer les instructions détaillées pour l'agent...",
    "cancel": "Annuler",
    "create": "Créer l'Agent",
    "creating": "Création..."
  },
  "edit": {
    "title": "Modifier l'Agent",
    "description": "Mettre à jour les informations et instructions de l'agent",
    "name": "Nom",
    "name_placeholder": "Entrer le nom de l'agent",
    "slug": "Slug",
    "slug_placeholder": "agent-slug",
    "instruction": "Instruction",
    "instruction_placeholder": "Entrer les instructions détaillées pour l'agent...",
    "cancel": "Annuler",
    "save": "Enregistrer les Modifications",
    "saving": "Enregistrement..."
  },
  "view": {
    "title": "Détails de l'Agent",
    "description": "Voir les informations et instructions de l'agent",
    "name": "Nom",
    "slug": "Slug",
    "instruction": "Instruction",
    "created_at": "Créé le",
    "updated_at": "Modifié le",
    "close": "Fermer"
  },
  "delete": {
    "title": "Supprimer l'Agent",
    "description": "Êtes-vous sûr de vouloir supprimer l'agent \"{{name}}\" ?",
    "warning": "Cette action ne peut pas être annulée.",
    "cancel": "Annuler",
    "delete": "Supprimer l'Agent",
    "deleting": "Suppression..."
  },
  "errors": {
    "createAgentFailed": "Échec de la création de l'agent",
    "deleteAgentFailed": "Échec de la suppression de l'agent",
    "loadAgentsFailed": "Échec du chargement des agents",
    "updateAgentFailed": "Échec de la mise à jour de l'agent"
  },
  "success": {
    "createAgentSuccess": "Agent créé avec succès",
    "updateAgentSuccess": "Agent mis à jour avec succès",
    "deleteAgentSuccess": "Agent supprimé avec succès"
  }
}
